module.exports = __webpack_public_path__ + "img/expirations.e36d09a2.svg";